enum PaymentFrequency {
  MONTHLY = 'Month',
  YEARLY = 'Year'
}

export default PaymentFrequency;
